import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import store from '@/store';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TheLogoImg',
  setup(__props) {

const whitelabeling = computed(() => store.getters.activeWhitelabeling);
const logotypeSrc = computed<string>(() => {
	if (!whitelabeling.value || !whitelabeling.value.logotype_path) {
		return require('@/assets/logo.svg');
	}

	return `/${whitelabeling.value.logotype_path}`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    src: logotypeSrc.value,
    alt: "Secure Channel"
  }, null, 8, _hoisted_1))
}
}

})